import { Check } from 'lucide-react';

import { cn } from '@/design-system/lib/cn';

/**
 * Marca visual de caixa de seleção (18px). O papel `checkbox` e o `aria-checked` ficam
 * no elemento clicável que a contém — no design, a linha inteira é o alvo.
 */
export function CheckboxMark({ checked, className }: { checked: boolean; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'grid size-4.5 shrink-0 place-items-center rounded-chip border-[1.5px] text-white',
        checked ? 'border-primary bg-primary' : 'border-ink-placeholder bg-white',
        className
      )}
    >
      {checked ? <Check className="size-3 stroke-3" /> : null}
    </span>
  );
}
